/**
 * TW FAQ — show scent-specific answer panels when scent changes.
 */
window.TwFaqScentSync = (function () {
  'use strict';

  function normalizeScentKey(key) {
    if (!key) return '';
    const k = String(key).trim().toLowerCase();
    if (k.includes('lavender')) return 'lavender';
    if (k.includes('citris') || k.includes('citrus') || k.includes('orange') || k.includes('lemon')) return 'citrus';
    if (
      k.includes('normal') ||
      k.includes('unscent') ||
      k.includes('fragrance-free') ||
      k.includes('fragrance free')
    ) {
      return 'unscented';
    }
    return k.replace(/\s+/g, '-');
  }

  function panelMatchesKey(panelKey, activeKey) {
    if (!panelKey || !activeKey) return false;
    if (panelKey === activeKey) return true;
    return normalizeScentKey(panelKey) === normalizeScentKey(activeKey);
  }

  function resolveScentKey(scentKey, variantId) {
    if (scentKey) return normalizeScentKey(scentKey);

    if (variantId) {
      const btn = document.querySelector(
        '.tw-scent-dropdown__option[data-variant-id="' + variantId + '"]'
      );
      if (btn && btn.getAttribute('data-scent-key')) {
        return normalizeScentKey(btn.getAttribute('data-scent-key'));
      }
    }

    const selectedOption = document.querySelector(
      '.tw-scent-dropdown__option[aria-selected="true"]'
    );
    if (selectedOption && selectedOption.getAttribute('data-scent-key')) {
      return normalizeScentKey(selectedOption.getAttribute('data-scent-key'));
    }

    const toggleLabel = document.querySelector(
      '.tw-scent-dropdown__toggle-inner .tw-scent-dropdown__option-label'
    );
    if (toggleLabel && toggleLabel.textContent) {
      return normalizeScentKey(toggleLabel.textContent.replace(/\s*\(sold out\)\s*/i, ''));
    }

    return '';
  }

  function sync(scentKey, variantId) {
    const activeKey = resolveScentKey(scentKey, variantId);

    document.querySelectorAll('[data-tw-faq-scent-answers]').forEach(function (container) {
      const panels = Array.from(container.querySelectorAll('[data-scent-key]'));
      if (!panels.length) return;

      let matched = false;

      if (activeKey) {
        panels.forEach(function (panel) {
          const key = panel.getAttribute('data-scent-key') || '';
          if (key === 'default') {
            panel.hidden = true;
            return;
          }
          const show = panelMatchesKey(key, activeKey) && panel.innerHTML.trim() !== '';
          panel.hidden = !show;
          if (show) matched = true;
        });
      }

      if (!matched) {
        const withContent = panels.filter(function (p) {
          return p.getAttribute('data-scent-key') !== 'default' && p.innerHTML.trim() !== '';
        });
        const fallback =
          withContent.find(function (p) {
            return activeKey && panelMatchesKey(p.getAttribute('data-scent-key') || '', activeKey);
          }) || withContent[0];

        panels.forEach(function (panel) {
          panel.hidden = panel !== fallback;
        });

        if (!fallback) {
          const defaultPanel = container.querySelector('[data-scent-key="default"]');
          if (defaultPanel && defaultPanel.innerHTML.trim() !== '') {
            defaultPanel.hidden = false;
          }
        }
      }
    });
  }

  function syncFromPage() {
    const params = new URLSearchParams(window.location.search);
    let variantId = params.get('variant');
    if (!variantId) {
      const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (input && input.value) variantId = input.value;
    }
    sync(null, variantId);
  }

  function bindVariantEvents() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const variant = event && event.data && event.data.variant;
      if (variant && variant.id) {
        sync(null, variant.id);
      }
    });

    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function () {
      window.setTimeout(syncFromPage, 50);
    });
  }

  function init() {
    syncFromPage();
    bindVariantEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    syncFromPage();
  });

  return { sync, syncFromPage, normalizeScentKey };
})();
